/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
export default [
  {
    width: 180,
    label: '项目参与人',
    maxLength: 50,
    tip: '请输入',
    key: 'userName',
    id: 'userName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '个体',
    tip: '请输入关键字',
    key: 'zooidEnterpriseName',
    id: 'zooidEnterpriseName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '手机号',
    tip: '请输入手机号',
    maxLength: 11,
    key: 'phone',
    id: 'phone',
    slot: 'input',
    clearable: true,
    input: value => {
      if (isNaN(parseInt(value))) return '';
      return parseInt(value);
    }
  },
  {
    width: 180,
    label: '入驻状态',
    tip: '请选择入驻状态',
    key: 'status',
    id: 'status',
    slot: 'select',
    clearable: true,
    options: [
      {
        key: 0,
        name: '未入驻'
      },
      {
        key: 1,
        name: '已入驻'
      },
      {
        key: 2,
        name: '已退出'
      },
      {
        key: 3,
        name: '不可入驻'
      }
    ]
  },
  {
    width: 180,
    label: '项目名称',
    tip: '请输入项目名称',
    key: 'projectName',
    id: 'projectName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '状态',
    tip: '请选择状态',
    key: 'auditStatus',
    id: 'auditStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        key: 0,
        name: '未审核'
      },
      {
        key: 1,
        name: '审核中'
      },
      {
        key: 2,
        name: '审核通过'
      },
      {
        key: 3,
        name: '审核未通过'
      }
    ]
  },
  {
    width: 180,
    label: '审核状态',
    tip: '请选择状态',
    key: 'checkStatus',
    id: 'checkStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        key: 1,
        name: '审核中'
      },
      {
        key: 2,
        name: '审核通过'
      },
      {
        key: 3,
        name: '审核未通过'
      },
      {
        key: 4,
        name: '申请已过期'
      }
    ]
  },
  {
    width: 180,
    label: '入驻状态',
    tip: '请选择入驻状态',
    key: 'enterStatus',
    id: 'enterStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        key: 0,
        name: '未入驻'
      },
      {
        key: 1,
        name: '已入驻'
      }
    ]
  },
  {
    width: 180,
    label: '审核状态',
    tip: '请选择状态',
    key: 'certificationStatus',
    id: 'certificationStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        key: 1,
        name: '待审核'
      },
      {
        key: 2,
        name: '审核通过'
      },
      {
        key: 3,
        name: '审核未通过'
      }
    ]
  },
  {
    width: 180,
    label: '审核状态',
    tip: '请选择状态',
    key: 'checkStatus',
    id: 'applyCertificationStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        key: 1,
        name: '审核中'
      },
      {
        key: 2,
        name: '审核通过'
      },
      {
        key: 3,
        name: '审核未通过'
      },
      {
        key: 4,
        name: '申请已过期'
      }
    ]
  },
  {
    width: 180,
    label: '资质证明',
    tip: '请选择资质证明',
    key: 'certificationUpload',
    id: 'certificationUpload',
    slot: 'select',
    clearable: true,
    options: [
      {
        key: 1,
        name: '已上传'
      },
      {
        key: 0,
        name: '未上传'
      }
    ]
  }
];
